import * as React from 'react';
import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';

function Checkbox(props: CheckboxProps, ref: React.Ref<HTMLInputElement>) {
  return <MuiCheckbox {...props} inputRef={ref} />;
}

export default React.forwardRef(Checkbox);
